import styled from 'styled-components';
import { Collapse } from 'antd';

export const CollapseWrapper = styled(Collapse)`
	border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
	margin-bottom: 16px;
	background-color: ${({ theme }) => theme.palette.secondary['50']};
	border: none;

	.ant-collapse-header {
		border: none;
		font-size: 18px;
		font-weight: 400;
		line-height: 22px;
		letter-spacing: 0%;
		color: #333;
		border-radius: 8px;
		border-bottom: none;
	}
	.ant-collapse-content {
		border: none;
		border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
	}

	.ant-collapse-item {
		border: none;
	}
	.ant-btn {
		border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
		height: 40px;
	}

	@media (max-width: 1389px) {
		.ant-collapse-header {
			font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
		}

		.ant-form-item-label > label {
			font-size: 12px !important;
		}

		.ant-input,
		.ant-select-selector,
		.ant-radio-wrapper {
			font-size: 12px !important;
		}

		.ant-input,
		.ant-select-selector {
			height: 32px !important;
			padding: 4px 8px !important;
			line-height: 1.2 !important;
		}

		.ant-input-number {
			height: 32px !important;
			font-size: 12px !important;
		}

		.ant-input-number-input {
			height: 30px !important;
			padding: 4px 8px !important;
		}

		.ant-btn {
			font-size: 12px;
			height: 32px;
		}

		.ant-form-item {
			margin-bottom: 7px;
		}
	}
`;
